module.exports = __webpack_public_path__ + "img/close.6ea64f65.svg";